import React, { useState } from 'react';

import PropTypes from 'prop-types';
import Modal from '@tds/community-modal';

import request from '../../utils/request';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { Button } from './css';

const QuoteReference = ({ orderData, fetchOrders }) => {
  const { id, isQuoteReference } = orderData;
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: {
      confirmationDialog,
      markAsQuoteReference,
      removeAsQuoteReference
    },
    formButtons: { confirmButtonLabel, cancelButtonLabel }
  } = localizedStrings;

  const [modalData, setModalData] = useState({
    isOpen: false,
    message: ''
  });
  const [referenceFlag, setReferenceFlag] = useState(false);

  const handleQuoteReference = () => {
    const body = {
      isQuoteReference: referenceFlag
    };
    request.put(`/orders/${id}`, body).then(() => {
      setModalData({
        isOpen: false,
        message: ''
      });
      fetchOrders();
    });
  };

  return (
    <>
      {!isQuoteReference && (
        <Button
          onClick={() => {
            setReferenceFlag(true);
            setModalData({
              isOpen: true,
              message: 'Are you sure you want to save this quote as reference?'
            });
          }}
        >
          {markAsQuoteReference}
        </Button>
      )}
      {isQuoteReference && (
        <Button
          onClick={() => {
            setReferenceFlag(false);
            setModalData({
              isOpen: true,
              message:
                'Are you sure you want to unmark this quote as reference?'
            });
          }}
        >
          {removeAsQuoteReference}
        </Button>
      )}
      <Modal
        heading={confirmationDialog}
        bodyText={modalData.message}
        confirmCTAText={confirmButtonLabel}
        cancelCTAText={cancelButtonLabel}
        onConfirm={() => handleQuoteReference()}
        onClose={() => setModalData(false)}
        isOpen={modalData.isOpen}
      />
    </>
  );
};

QuoteReference.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default QuoteReference;
